import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

import LOCAL_COLORS from 'styles/constants/colors';

export const MainContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${LOCAL_COLORS.surfaceDarkBold};
  padding-top: ${SPACER.xlarge};
`;

export const InnerContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${SPACER.xlarge} ${SPACER.medium} ${SPACER.x3large} ${SPACER.medium};
  max-width: 1440px;

  ${MEDIA_QUERIES.xlUp} {
    padding: 0 4.5rem 4.5rem;
  }
`;

export const HeaderContainer = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 130%;
  color: ${LOCAL_COLORS.textInverse};
  padding-bottom: 3rem;
  width: 75%;

  ${MEDIA_QUERIES.xlUp} {
    font-size: 2rem;
    width: 100%;
    padding-bottom: 4.5rem;
  }
`;

export const buttonStyles = css`
  row-gap: 0;
  max-width: 100%;

  ${MEDIA_QUERIES.smUp} {
    width: 272px;
    margin: 0;
  }
`;
